export enum orderStatus {
  None = 1,
  ArriveToDrop = 2,
  OnBridge = 3,
  InProgress = 4,
  ReadyToDeliver = 5,
  PaymentConfirm = 6,
  Complete = 7
}

export enum themeName {
  Default = 'defaultTheme',
  SytnerTheme = 'sytnerTheme'
}
